import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { messageSelector } from '../../selectors/messages';
import { noReplySelector } from '../../selectors/patient';
import { RootState } from '../../store';
import { Message, SenderStatus } from '../../types';
import UserAvatar from '../UserAvatar';
import MessageSubTypes from '../../models/enums/MessageSubTypes';

import { ReactComponent as SupportSvg } from '../../images/icon-support.svg';
import MessageBubble from './MessageBubble';
import MessageStatusFailedRetry from './MessageStatusFailedRetry';

import styles from './MessageItem.module.css';

export function MessageItem({
  message,
  noReply,
  timelineRef,
  messageIdSnapshot,
}: {
  message: Message;
  noReply: boolean;
  timelineRef: React.RefObject<HTMLElement>;
  messageIdSnapshot: string[];
}) {
  const { sender, isOutgoing, senderStatus, subType } = message;
  const isFailedOrRetrying =
    senderStatus === SenderStatus.Failed || senderStatus === SenderStatus.Retrying;
  const isSmsAutomatedOptMessage =
    subType === MessageSubTypes.SMS_OPT_OUT_NOTIFICATION ||
    subType === MessageSubTypes.SMS_OPT_IN_NOTIFICATION;
  const isVwrBotMessage = subType === MessageSubTypes.CHATBOT_MESSAGE;
  const shouldShowAvatar = !isOutgoing && !isVwrBotMessage && !isSmsAutomatedOptMessage;

  return (
    <div
      className={classNames({
        [styles.messageItem]: true,
        [styles.outgoingMessage]: isOutgoing,
        [styles.smsAutomatedOptMessage]: isSmsAutomatedOptMessage,
      })}
    >
      {isVwrBotMessage && <SupportSvg />}
      {shouldShowAvatar && <UserAvatar user={sender} />}
      <div>
        <MessageBubble
          message={message}
          timelineRef={timelineRef}
          messageIdSnapshot={messageIdSnapshot}
          noReply={noReply}
        />
        {isOutgoing && isFailedOrRetrying && (
          <MessageStatusFailedRetry message={message} senderStatus={senderStatus} />
        )}
      </div>
    </div>
  );
}

const mapState = (state: RootState, props: unknown) => ({
  message: messageSelector(state, props),
  messageIdSnapshot: state.messageLoad.messageIdSnapshot,
  noReply: noReplySelector(state),
});

const mapDispatch = null;

export default connect(mapState, mapDispatch)(MessageItem);
